import {AttributesInterface} from '@api/item';
import Link from 'next/link';
import React from 'react';

const Properties = ({
  attributes,
  slug,
  redeem,
}: {
  attributes: Array<AttributesInterface>;
  slug?: string;
  redeem?: boolean;
}) => {
  return (
    <>
      {/* <!-- Properties --> */}
      <div
        className="tab-pane fade"
        id="properties"
        role="tabpanel"
        aria-labelledby="properties-tab"
      >
        {attributes.length > 0 ? (
          <div className="dark:bg-black-green-2 dark:border-none border-light-grey rounded-t-2lg rounded-2lg border bg-white p-6 md:p-10 overflow-x-auto">
            <div
              className={
                redeem
                  ? 'grid grid-cols-2 gap-5'
                  : 'grid grid-cols-2 gap-5 sm:grid-cols-3 md:grid-cols-4'
              }
            >
              {attributes.map((item) => {
                const {id, trait_type, value, nusa_attribute_type} = item;
                // REDEEM ITEM
                if (redeem) {
                  if (nusa_attribute_type === 'PROPERTIES') {
                    return (
                      <Link
                        href={`/collection/${slug}?attributes[${trait_type}][]=${value}`}
                        key={id}
                      >
                        <a className="dark:bg-black-green md:w-[180px] md:h-[85px] w-full h-[50px] bg-green-light gradient-border rounded-2lg flex flex-col justify-center gap-4 text-center transition-shadow hover:shadow-lg">
                          <span className="font-display-2 text-center font-semibold text-xs md:text-sm gradient-text uppercase">
                            {trait_type}
                          </span>
                          <span className="font-display-2 text-dark-grey text-sm md:text-lg dark:text-light-grey capitalize">
                            {value}
                          </span>
                        </a>
                      </Link>
                    );
                  }
                } else {
                  // NORMAL ITEM
                  if (nusa_attribute_type === 'PROPERTIES') {
                    return (
                      <Link
                        href={`/collection/${slug}?attributes[${trait_type}][]=${value}`}
                        key={id}
                      >
                        <a className="dark:bg-black-green w-[180px] h-[85px] bg-green-light gradient-border rounded-2lg flex flex-col justify-center gap-4 text-center transition-shadow hover:shadow-lg">
                          <span className="font-display-2 text-center font-semibold text-sm gradient-text uppercase">
                            {trait_type}
                          </span>
                          <span className="font-display-2 text-dark-grey text-lg dark:text-light-grey capitalize">
                            {value}
                          </span>
                        </a>
                      </Link>
                    );
                  }
                }
              })}
            </div>
          </div>
        ) : (
          <div className="flex justify-center">
            <p
              className={
                redeem
                  ? 'text-dark-navy dark:text-white text-sm md:text-lg font-normal font-display'
                  : 'text-dark-navy dark:text-white text-lg font-normal font-display '
              }
            >
              Properties not available on this item
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default Properties;
